import ajax from '../assets/js/ajax'
import cookie from '../assets/js/cookie'
import {AUTH_KEY} from '../assets/js/config'
const state = {
  curUser: null
}
const actions = {
  initUser (ctx) {
    return ajax.get('/zhaopin/b/company/info.json')
      .then(data => ctx.commit('initUser', data))
  },
  login (ctx, params) {
    return ajax.post('/user/logon.json', params)
      .then(() => ctx.dispatch('initUser'))
  },
  register (ctx, params) {
    return ajax.post('/user/register.json', params)
  },
  sendCode (ctx, params) {
    return ajax.get('/user/getrandcode.json', params)
  },
  logout (ctx, params) {
    return ajax.get('/user/logout.json', params)
      .then(() => ctx.commit('logout'))
      .catch(err => {
        console.error(err)
        return ctx.commit('logout')
      })
  },
  findPasswd (ctx, params) {
    return ajax.post('/user/resetpwd.json', params)
  },
  changePwd (ctx, params) {
    return ajax.post('/user/changepwd.json', params)
      .then(() => ctx.commit('logout'))
  }
}
const mutations = {
  initUser (state, data) {
    state.curUser = data
  },
  logout (state) {
    cookie.del(AUTH_KEY)
    cookie.del(AUTH_KEY, '/', '.easteat.com')
    state.curUser = null
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/passport.js